export const FormFieldsMap = {
  HiringAuthorityInsights: {
    key: 'hiringAuthorityInsights'
  },
  CandidateInsights: {
    key: 'candidateInsights'
  }
};
